import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { compose } from 'redux';
import classNames from 'classnames';
import some from 'lodash/some'
import moment from 'moment'
import { Panel } from 'primereact/panel';

import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { confirmDialog } from 'primereact/confirmdialog';
import { Dropdown } from 'primereact/dropdown';


import Header from '@components/Header';
import SupplierConfirmModal from '@components/Suppliers/SupplierConfirmModal';

import { updateSupplier } from '@actions/supplier'
import { getAllBlacklistDomains } from '@actions/blacklist'
import { getCountriesOfficials } from '@actions/countries'
import { sendActionToBitacora  } from '@actions/bitacora';

import { rexgexEmail, LANGUAGE_DEFAULT } from '@constants/general'

const OTHER_COUNTRY = 'Otro'
// import './style.scss'

class SearchSupplier extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loadingPage: true,
      btnSubmitLoading: false,
      errors: [],
      id: "",
      correo: "",
      nombre: "",
      estatus: "",
      pais: "",
      razon_social: "",
      documento: "",
      telefono: "",
      adicional_nombre: "",
      adicional_telefono: "",
      adicional_correo: "",
      fecha_vencimiento: "",
      pendientes: "",
      fullData: {},
      showModalConfirm: {
        isVisible: false
      },
      domains: [],
      officialCountries: [],
      otherCountry: ""
    };
  }

  async componentDidMount () {
    const { t, history, getAllBlacklistDomains, getCountriesOfficials } = this.props
    if(!history.location.state?.id) return history.push('/supplier/search')

    let countriesOfficials = []
    const resolvePromise = await  Promise.all([getAllBlacklistDomains(), getCountriesOfficials()])
    resolvePromise.map((resolve, index) => {
      if (!resolve?.status) {
        if (index === 0) {
          this.setState({
            domains: resolve.data
          });
        }
        if (index === 1) {
          const formatCountries = resolve.data.map(item => ({label: JSON.parse(item.nombre)[LANGUAGE_DEFAULT], value: JSON.parse(item.nombre)[LANGUAGE_DEFAULT]}))
          formatCountries.push({label: t('Otro'), value: OTHER_COUNTRY })
          countriesOfficials = formatCountries
          this.setState({
            officialCountries: formatCountries
          });
        }
      }
      return true
    })

    const isCountryOfficial =  countriesOfficials.find(item => item.value === history.location.state?.pais)

    if (isCountryOfficial) {
      this.setState({
        "pais":history.location.state?.pais,
      })
    } else {
      this.setState({
        "pais": OTHER_COUNTRY,
        otherCountry: history.location.state?.pais
      })
    }

    return this.setState({
      loadingPage: false,
      "id":history.location.state?.id,
      "correo":history.location.state?.correo,
      "nombre":history.location.state?.nombre,
      "estatus":history.location.state?.estatus,
      "razon_social":history.location.state?.razon_social,
      "documento":history.location.state?.documento,
      "telefono":history.location.state?.telefono,
      "adicional_nombre":history.location.state?.adicional_nombre,
      "adicional_telefono":history.location.state?.adicional_telefono,
      "adicional_correo":history.location.state?.adicional_correo,
      "fecha_vencimiento": history.location.state?.fecha_vencimiento,
      "pendientes":history.location.state?.pendientes,
      fullData: {...history.location.state}
    })
  }

  onChange = ({target}) => {
    this.setState({[target.name]: target.value}, this.validateFieldsOnchange(target.name, target.value));
  };

  validateFieldsOnchange = (name, value) => {
    const { errors } = this.state
    if (errors[name] && value) {
      delete errors[name]
      this.setState({errors})
    }
  }

  validateLabelInput = (key) => {
    const { t } = this.props
    switch (key) {
      case 'id':
        return t('Id');
        case 'correo':
          return t('Correo electrónico');
        case 'nombre':
          return t('Nombre');
        case 'estatus':
          return t('Estatus');
        case 'pais':
          return t('País de ubicación');
        case 'razon_social':
          return t('Razon Social o Denominación');
        case 'documento':
          return t('Cedula de Identificación Fiscal');
        case 'telefono':
          return t('Teléfono');
        case 'adicional_nombre':
          return t('Nombre adicional');
        case 'adicional_telefono':
          return t('Teléfono adicional');
        case 'adicional_correo':
          return t('Correo electrónico adicional');
        case 'fecha_vencimiento':
          return t('Fecha de vencimiento');
        case 'pendientes':
          return t('Procesos');
        case 'Otro país':
          return t('Otro país');
      default:
        return key;
    }
  }

  onUpdateSupplier = async (data, justification) => {
    const { updateSupplier, history, t, sendActionToBitacora} = this.props
    const { id, correo } = this.state
    this.setState({ btnSubmitLoading: true });
    const formatData = data.reduce((accum, item) => {
      accum.[item.key] = item.value
      return accum
    }, {})
    const response  = await updateSupplier({ ...formatData, id})
    if (!response.status) {
      const dataBitacora = {
        transactionName: 'actProveedor',
        reason: `${correo} || ${justification}`,
      }
      await sendActionToBitacora(dataBitacora)
      this.setState({ btnSubmitLoading: false });
      this.onHideModalConfirm()
      return confirmDialog({
        message: t('La operación se ha realizado de manera éxitosa'),
        header: t('Confirmación'),
        icon: 'pi pi-check-circle',
        acceptLabel: t('Continuar'),
        rejectClassName: 'hide-component',
        accept: () => history.push('/supplier/search'),
        onHide: () => history.push('/supplier/search')
      });
    }
    this.onHideModalConfirm()
    this.setState({ btnSubmitLoading: false });
  }

  onSubmit = async (e) => {
    const { t } = this.props
    if (e) e.preventDefault();
    const validate = await this.validateFields()
    if (some(validate, {})) return true
    const validateDifferences = this.validateDifferenceValues()
    if (!validateDifferences.length) {
      return confirmDialog({
        message: t('No se ha encontrado ningún cambio'),
        header: t('Detalle de proveedor'),
        icon: `pi pi-exclamation-triangle`,
        acceptLabel: t('Cerrar'),
        rejectClassName: 'hide-component',
        accept: () => {},
      });
    }
    const getDetailDifference = validateDifferences.map(item => {
      if (item === 'pais' && this.state[item] === OTHER_COUNTRY) return { key: item,  value: this.state.otherCountry, label: this.validateLabelInput(item)}
      return { key: item,  value: this.state[item], label: this.validateLabelInput(item)}
    })
    this.setState({showModalConfirm: {
      isVisible: true,
      data: getDetailDifference,
      continueAction: (justification) => this.onUpdateSupplier(getDetailDifference, justification)
    }})
  };

  validateFields = async () => {
    const { t } = this.props
    const { correo, nombre, estatus, pais, documento, razon_social, telefono, adicional_nombre, adicional_telefono, adicional_correo, fecha_vencimiento, otherCountry } = this.state
    let errors = {}

    if (!correo) errors = {...errors, [`correo`]: `${t('Correo electrónico')} ${t('es requerido')}`}
    else if (!rexgexEmail.test(correo)) errors = { ...errors, 'correo': `${t('Correo electrónico')} ${t('es invalido')}`  }
    else if (this.isCorrectDomain(correo)) errors = { ...errors, 'correo': `${t('Dominio de correo no válido')}`  }

    if (!nombre) errors = {...errors, [`nombre`]: `${t('Nombre')} ${t('es requerido')}`}
    // if (!estatus) errors = {...errors, [`estatus`]: `${t('Estatus')} ${t('es requerido')}`}
    if (!pais) errors = {...errors, [`pais`]: `${t('País de ubicación')} ${t('es requerido')}`}
    if (pais === OTHER_COUNTRY && !otherCountry) errors = {...errors, [`otherCountry`]: `${t('País de ubicación')} ${t('es requerido')}`}
    if (!razon_social) errors = {...errors, [`razon_social`]: `${t('Razon Social o Denominación')} ${t('es requerido')}`}
    if (!documento) errors = {...errors, [`documento`]: `${t('Cedula de Identificación Fiscal')} ${t('es requerido')}`}
    if (!telefono) errors = {...errors, [`telefono`]: `${t('Teléfono')} ${t('es requerido')}`}
    if (!adicional_nombre) errors = {...errors, [`adicional_nombre`]: `${('Nombre adicional')} ${t('es requerido')}`}
    if (!adicional_telefono) errors = {...errors, [`adicional_telefono`]: `${t('Teléfono adicional')} ${t('es requerido')}`}

    if (!adicional_correo) errors = {...errors, [`adicional_correo`]: `${t('Correo adicional')} ${t('es requerido')}`}
    else if (!rexgexEmail.test(adicional_correo)) errors = { ...errors, 'adicional_correo': `${t('Correo adicional')} ${t('es invalido')}`  }
    else if (this.isCorrectDomain(adicional_correo)) errors = { ...errors, 'adicional_correo': `${t('Dominio de correo no válido')}`  }

    if (!fecha_vencimiento) errors = {...errors, [`fecha_vencimiento`]: `${t('Fecha de vencimiento')} ${t('es requerido')}`}
    // if (!pendientes) errors = {...errors, [`pendientes`]: `${t('Pendiente')} ${t('es requerido')}`}

    this.setState({errors})
    return errors
  }

  validateDifferenceValues = () => {
    const { fullData, otherCountry } = this.state
    return Object.keys(fullData).reduce((accum, key) => {
      if (key === 'pais') {
        if (this.state[key] === OTHER_COUNTRY ) {
          if (fullData[key] !== otherCountry) {
            accum.push(key)
          }
        } else if (fullData[key] !== this.state[key]) {
          accum.push(key)
        }
      } else if (fullData[key] !== this.state[key]) accum.push(key)
      return accum
    }, [])
  }

  isCorrectDomain = (correo) => {
    const { domains } = this.state
    const hasDomainBlackList = domains.find(item => correo.includes(item.dominio))
    return hasDomainBlackList
  }

  onHideModalConfirm = () => {
    this.setState({
      showModalConfirm: {
        isVisible: false,
      },
    });
  };

  render() {
    const { t, history } = this.props;
    const { errors, loadingPage, btnSubmitLoading, showModalConfirm, officialCountries } = this.state;

    const isFormFieldValid = (name) => !!errors[name];
    const getFormErrorMessage = (name) =>
      isFormFieldValid(name) && (
        <small className="p-error">{errors[name]}</small>
      );

    if (loadingPage) return true
    return (
      <div className="p-grid">
        <div className="p-col-12">
          <Header title={t('Detalle de proveedor')} linkText={t("Ir al listado")} to="/supplier/search" />
          <form  onSubmit={this.onSubmit} autoComplete="false" className='card'>
            <Panel header={t('Datos del Representante Legal')} className='p-mb-3 p-mt-3'>
              <div className='p-fluid p-grid'>
                <div className="p-col-12 p-lg-4 p-field">
                  <label htmlFor="title" className="p-text-bold p-pb-2">
                    {this.validateLabelInput('id')}
                  </label>
                  <p>{this.state.id}</p>
                  {/* <InputText
                    name="id"
                    type="text"
                    value={this.state.id}
                    // onChange={this.onChange}
                    className={classNames({
                      'p-invalid': isFormFieldValid(`id`),
                    })}
                    disabled
                  />
                  {getFormErrorMessage(`id`)} */}
                </div>
                <div className="p-col-12 p-lg-4 p-field">
                  <label htmlFor="title" className="p-text-bold p-pb-2">
                  {this.validateLabelInput('correo')}
                  </label>
                  <InputText
                    name="correo"
                    type="text"
                    value={this.state.correo}
                    onChange={this.onChange}
                    className={classNames({
                      'p-invalid': isFormFieldValid(`correo`),
                    })}
                  />
                  {getFormErrorMessage(`correo`)}
                </div>
                <div className="p-col-12 p-lg-4 p-field">
                  <label htmlFor="title" className="p-text-bold p-pb-2">
                    {this.validateLabelInput('nombre')}
                  </label>
                  <InputText
                    name="nombre"
                    type="text"
                    value={this.state.nombre}
                    onChange={this.onChange}
                    className={classNames({
                      'p-invalid': isFormFieldValid(`nombre`),
                    })}
                  />
                  {getFormErrorMessage(`nombre`)}
                </div>
                <div className="p-col-12 p-lg-4 p-field">
                  <label htmlFor="title" className="p-text-bold p-pb-2">
                    {this.validateLabelInput('razon_social')}
                  </label>
                  <InputText
                    name="razon_social"
                    type="text"
                    value={this.state.razon_social}
                    onChange={this.onChange}
                    className={classNames({
                      'p-invalid': isFormFieldValid(`razon_social`),
                    })}
                  />
                  {getFormErrorMessage(`razon_social`)}
                </div>
                <div className="p-col-12 p-lg-4 p-field">
                  <label htmlFor="title" className="p-text-bold p-pb-2">
                    {this.validateLabelInput('documento')}
                  </label>
                  <InputText
                    name="documento"
                    type="text"
                    value={this.state.documento}
                    onChange={this.onChange}
                    className={classNames({
                      'p-invalid': isFormFieldValid(`documento`),
                    })}
                  />
                  {getFormErrorMessage(`documento`)}
                </div>
                <div className="p-col-12 p-lg-4 p-field">
                  <label htmlFor="title" className="p-text-bold p-pb-2">
                    {this.validateLabelInput('pais')}
                  </label>
                  <Dropdown
                    name="pais"
                    value={this.state.pais}
                    options={officialCountries}
                    onChange={this.onChange}
                    optionLabel="label"
                    filterBy="label"
                    placeholder=""
                    style={{ width: '100%' }}
                  />
                  {getFormErrorMessage(`pais`)}
                </div>
                { this.state.pais === OTHER_COUNTRY && (
                  <div className="p-col-12 p-lg-4 p-field">
                    <label htmlFor="title" className="p-text-bold p-pb-2">
                      {this.validateLabelInput('Otro país')}
                    </label>
                    <InputText
                      name="otherCountry"
                      type="text"
                      value={this.state.otherCountry}
                      onChange={this.onChange}
                      className={classNames({
                        'p-invalid': isFormFieldValid(`otherCountry`),
                      })}
                    />
                    {getFormErrorMessage(`otherCountry`)}
                  </div>
                )}
                <div className="p-col-12 p-lg-4 p-field">
                  <label htmlFor="title" className="p-text-bold p-pb-2">
                    {this.validateLabelInput('telefono')}
                  </label>
                  <InputText
                    name="telefono"
                    type="text"
                    value={this.state.telefono}
                    onChange={this.onChange}
                    className={classNames({
                      'p-invalid': isFormFieldValid(`telefono`),
                    })}
                    keyfilter="num"
                  />
                  {getFormErrorMessage(`telefono`)}
                </div>
              </div>
            </Panel>

            <Panel header={t('Datos de Contacto Adicional')} className='p-mb-3' toggleable collapsed>
              <div className='p-fluid p-grid'>
                <div className="p-col-12 p-lg-4 p-field">
                  <label htmlFor="title" className="p-text-bold p-pb-2">
                    {this.validateLabelInput('adicional_nombre')}
                  </label>
                  <InputText
                    name="adicional_nombre"
                    type="text"
                    value={this.state.adicional_nombre}
                    onChange={this.onChange}
                    className={classNames({
                      'p-invalid': isFormFieldValid(`adicional_nombre`),
                    })}
                  />
                  {getFormErrorMessage(`adicional_nombre`)}
                </div>
                <div className="p-col-12 p-lg-4 p-field">
                  <label htmlFor="title" className="p-text-bold p-pb-2">
                    {this.validateLabelInput('adicional_telefono')}
                  </label>
                  <InputText
                    name="adicional_telefono"
                    type="text"
                    value={this.state.adicional_telefono}
                    onChange={this.onChange}
                    className={classNames({
                      'p-invalid': isFormFieldValid(`adicional_telefono`),
                    })}
                    keyfilter="num"
                  />
                  {getFormErrorMessage(`adicional_telefono`)}
                </div>
                <div className="p-col-12 p-lg-4 p-field">
                  <label htmlFor="title" className="p-text-bold p-pb-2">
                    {this.validateLabelInput('adicional_correo')}
                  </label>
                  <InputText
                    name="adicional_correo"
                    type="text"
                    value={this.state.adicional_correo}
                    onChange={this.onChange}
                    className={classNames({
                      'p-invalid': isFormFieldValid(`adicional_correo`),
                    })}
                  />
                  {getFormErrorMessage(`adicional_correo`)}
                </div>
              </div>
            </Panel>

            <Panel header={t('Información adicional')} className='p-mb-3' toggleable collapsed>
              <div className='p-fluid p-grid'>
                <div className="p-col-12 p-lg-4 p-field">
                  <label htmlFor="title" className="p-text-bold p-pb-2">
                    {this.validateLabelInput('estatus')}
                  </label>
                  <InputText
                    name="estatus"
                    type="text"
                    value={this.state.estatus}
                    // onChange={this.onChange}
                    className={classNames({
                      'p-invalid': isFormFieldValid(`estatus`),
                    })}
                    disabled
                  />
                  {getFormErrorMessage(`estatus`)}
                </div>
                <div className="p-col-12 p-lg-4 p-field">
                  <label htmlFor="title" className="p-text-bold p-pb-2">
                    {this.validateLabelInput('fecha_vencimiento')}
                  </label>
                  <InputText
                    name="fecha_vencimiento"
                    type="text"
                    value={moment(this.state.fecha_vencimiento).format("DD/MM/YYYY")}
                    onChange={this.onChange}
                    className={classNames({
                      'p-invalid': isFormFieldValid(`fecha_vencimiento`),
                    })}
                    disabled
                  />
                  {/* <Calendar
                    name="fecha_vencimiento"
                    value={this.state.fecha_vencimiento} 
                    onChange={this.onChange}
                    minDate={new Date()}
                    
                  /> */}
                  {getFormErrorMessage(`fecha_vencimiento`)}
                </div>
                <div className="p-col-12 p-lg-4 p-field">
                  <label htmlFor="title" className="p-text-bold p-pb-2">
                    {this.validateLabelInput('pendientes')}
                  </label>
                  <InputText
                    name="pendientes"
                    type="text"
                    value={this.state.pendientes}
                    // onChange={this.onChange}
                    className={classNames({
                      'p-invalid': isFormFieldValid(`pendientes`),
                    })}
                    disabled
                  />
                  {getFormErrorMessage(`pendientes`)}
                </div>
              </div>
            </Panel>

            <div className="p-col-12 footer-btn">
              <div className="p-d-flex p-jc-between">
                <Button
                  label={t('Cancelar')}
                  type="button"
                  className="p-button-secondary"
                  onClick={() => history.push('/supplier/search')}
                />
                <Button
                  label={t('Actualizar proveedor')}
                  type="submit"
                  className="p-button-primary"
                  loading={btnSubmitLoading}
                />
              </div>
            </div>
          </form>
        </div>
        { showModalConfirm.isVisible && (
          <SupplierConfirmModal
            display={showModalConfirm.isVisible}
            data={showModalConfirm.data}
            onHidden={() => this.onHideModalConfirm()}
            onContinueAction={showModalConfirm.continueAction}
            btnSubmitLoading={btnSubmitLoading}
          />
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
});

const mapDispatchToProps = {
  updateSupplier,
  getAllBlacklistDomains,
  getCountriesOfficials,
  sendActionToBitacora
};

export default compose(
  withTranslation(),
  connect(mapStateToProps, mapDispatchToProps)
)(SearchSupplier);
